export const createImagePreview = (
  blob: Blob,
  isCurrentRequest: () => boolean
): {file: File; previewUrl: string} | null => {
  const previewUrl = URL.createObjectURL(blob);

  if (!isCurrentRequest()) {
    URL.revokeObjectURL(previewUrl);
    return null;
  }

  return {
    file: new File([blob], 'captured-image.jpg', {type: 'image/jpeg'}),
    previewUrl
  };
};
